import './side.less'
import Slider from '../slider/index.jsx'
import React from 'react'
import UploadPictures from '../uploadPictures/index.jsx'
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken'
import { Select, Input } from 'antd'
// const { Option } = Select
console.log(React)

export default function TopImageSide(props) {
  const currentIndex = props.ifon.currentIndex

  return (<div className='TopImageSideSide'>
    <div className='TopImageSideSide_multiGraph'>
      <h3 className='multiGraph_title'>多图</h3>
      <div className='multiGraphBox'>
        {props.ifon.imageList.map((item, index) => {
          return (<li className={`multiGraphBox_item ${props.ifon.currentIndex === index ? 'active' : ''}`}
            key={item.id} onClick={() => {
              if (props.mySetIfon) {
                props.ifon.currentIndex = index
                props.mySetIfon(props.ifon)
              }
            }}>
            <img className='item_img' src={item.fileIfon.src} />
            <i className='item_icon' onClick={(e) => {
              e.stopPropagation()
              props.ifon.imageList.splice(index, 1)
              props.mySetIfon(props.ifon)
            }}>X</i>
          </li>)
        })}

        {props.ifon.imageList.length < 5 && <UploadPictures change={(e, func) => {
          uploadPictures(props, e, func, func1)
        }}></UploadPictures>}

      </div>
      <span className='multiGraph_tips'>图片要求：png/jpg/jpeg/gif, 小于3M, 最大1080*1920, 最多5张</span>
    </div>

    {props.ifon.imageList.length && <div className='TopImageSideSide_main'>
      <div className='main_box1'>
        <h3 className='box1_title'>图片样式</h3>
        <span className='title_tips'>每张图片可定义不同的可点击区域和跳转逻辑，设置时，请在上方选中对应图片</span>
        <div className='box_ifon'>
          <span className='ifon_title'>边距</span>
          <div className='item'>
            <Slider defaultValue={props.ifon.imageList[currentIndex].fileIfon.paddingTop} maxValue={50} change={(value) => {
              props.ifon.imageList[currentIndex].fileIfon.paddingTop = value
              props.mySetIfon(props.ifon)
            }}>上</Slider>
          </div>
          <div className='item'>
            <Slider defaultValue={props.ifon.imageList[currentIndex].fileIfon.paddingBottom} maxValue={50} change={(value) => {
              props.ifon.imageList[currentIndex].fileIfon.paddingBottom = value
              props.mySetIfon(props.ifon)
            }}>下</Slider>
          </div>
          <div className='item'>
            <Slider defaultValue={props.ifon.imageList[currentIndex].fileIfon.paddingLeft} change={(value) => {
              props.ifon.imageList[currentIndex].fileIfon.paddingLeft = value
              props.mySetIfon(props.ifon)
            }}>左</Slider>
          </div>
          <div className='item'>
            <Slider defaultValue={props.ifon.imageList[currentIndex].fileIfon.paddingRight} change={(value) => {
              props.ifon.imageList[currentIndex].fileIfon.paddingRight = value
              props.mySetIfon(props.ifon)
            }}>右</Slider>
          </div>
        </div>
      </div>

      <div className='switchT'>
        <span className='switchT_text'>设置热区</span>
        <div className={`switch ${props.ifon.imageList[currentIndex].isHotZone ? 'open' : ''}`}>
          <i className='switch_icon' onClick={() => {
            props.ifon.imageList[currentIndex].isHotZone = !props.ifon.imageList[currentIndex].isHotZone
            props.mySetIfon(props.ifon)
          }}></i>
        </div>
      </div>

      <div className='Boxtips'>
        <span className='tips'>多热区重叠区域，点击后优先跳转编号大的热区地址</span>
        <span className='tips'>可直接在图片上编辑热区位置和大小</span>
      </div>

      {props.ifon.imageList[currentIndex].isHotZone && <div className='main_box2'>
        <span className='box2_title1'>热区数量</span>
        <div className='main'>
          <ul className='main_ul'>
            <li className={`ul_li ${props.ifon.imageList[currentIndex].hotZoneQuantity.length === 1 ? 'active' : ''}`} onClick={() => {
              props.ifon.imageList[currentIndex].hotZoneQuantity.splice(1, 2)
              props.mySetIfon(props.ifon)
            }}>1个</li>
            <li className={`ul_li ${props.ifon.imageList[currentIndex].hotZoneQuantity.length === 2 ? 'active' : ''}`} onClick={() => {
              const num = props.ifon.imageList[currentIndex].hotZoneQuantity.length
              const bool = num < 2
              if (bool) {
                props.ifon.imageList[currentIndex].hotZoneQuantity.push(2)
              } else {
                props.ifon.imageList[currentIndex].hotZoneQuantity.splice(2, 1)
              }
              props.mySetIfon(props.ifon)
            }}>2个</li>
            <li className={`ul_li ${props.ifon.imageList[currentIndex].hotZoneQuantity.length === 3 ? 'active' : ''}`} onClick={() => {
              const num = props.ifon.imageList[currentIndex].hotZoneQuantity.length
              const bool = num < 3
              if (bool) {
                for (let i = num; i < 3; i++) {
                  props.ifon.imageList[currentIndex].hotZoneQuantity.push(i + 1)
                }

                props.mySetIfon(props.ifon)
              }
            }}>3个</li>
          </ul>
        </div>
      </div>}

      {props.ifon.imageList[props.ifon.currentIndex].isHotZone &&

        props.ifon.imageList[props.ifon.currentIndex].hotZoneQuantity.map((item, index) => {
          return (<div className='hotZone' key={index}>
            <h3 className='hotZone_title'>热区{index + 1}</h3>
            <div className='hotZone_main'>
              <div className='main_item'>
                <span className='item_title'>点击前往</span>
                <div className='Box' onClick={(e) => {
                  props.ifon.imageList[currentIndex].hotZone[index].goTo = parseInt(e.target.dataset.index)
                  props.mySetIfon(props.ifon)
                }}>
                  <li data-index={0} className={`Box_li ${props.ifon.imageList[currentIndex].hotZone[index].goTo === 0 ? 'active' : ''}`}>顶部</li>
                  <li data-index={1} className={`Box_li ${props.ifon.imageList[currentIndex].hotZone[index].goTo === 1 ? 'active' : ''}`}>底部</li>
                  <li data-index={2} className={`Box_li ${props.ifon.imageList[currentIndex].hotZone[index].goTo === 2 ? 'active' : ''}`}>关注公众号</li>
                  <li data-index={3} className={`Box_li ${props.ifon.imageList[currentIndex].hotZone[index].goTo === 3 ? 'active' : ''}`}>外部链接</li>
                </div>
              </div>

              { props.ifon.imageList[currentIndex].hotZone[index].goTo === 2 && <div className='main_item'>
                <span className='item_title'>微信公众号</span>
                <div className='box'>
                  <div className='item'>
                    <Select placeholder='请输入公众号'
                      showSearch
                      bordered
                      notFoundContent={'暂无数据'}
                      style={{ width: '80%' }}
                    >
                      {/* <Option>123</Option> */}
                    </Select>
                    <span className='tips'>刷新</span>
                  </div>
                </div>
              </div> }

              { props.ifon.imageList[currentIndex].hotZone[index].goTo === 3 && <div className='main_item'>
                <span className='item_title'>网页链接</span>
                <div className='box'>
                  <div className='item'>
                    <Input placeholder='如：http://www.baidu.com' value={props.ifon.imageList[currentIndex].hotZone[index].link} onChange={(e) => {
                      props.ifon.imageList[currentIndex].hotZone[index].link = e.target.value
                      props.mySetIfon(props.ifon)
                    }}></Input>
                  </div>
                </div>
              </div>}

              <div className='main_item'>
                <span className='item_title'>热区尺寸</span>
                <div className='box'>
                  <div className='item'>
                    <Slider
                      defaultValue={props.ifon.imageList[currentIndex].hotZone[index].width}
                      maxValue={props.ifon.imageList[currentIndex].hotZone[index].Width}
                      change={(value) => {
                        handleHotZone(currentIndex, index, props, '宽度', value)
                      }}
                    >宽度</Slider>
                  </div>
                  <div className='item'>
                    <Slider
                      defaultValue={props.ifon.imageList[currentIndex].hotZone[index].height}
                      maxValue={props.ifon.imageList[currentIndex].hotZone[index].Height}
                      change={(value) => {
                        handleHotZone(currentIndex, index, props, '高度', value)
                      }}
                    >高度</Slider>
                  </div>
                </div>
              </div>

              <div className='main_item'>
                <span className='item_title'>热区位置</span>
                <div className='box'>
                  <div className='item'>
                    <Slider
                      defaultValue={props.ifon.imageList[currentIndex].hotZone[index].x}
                      maxValue={props.ifon.imageList[currentIndex].hotZone[index].X}
                      change={(value) => {
                        handleHotZone(currentIndex, index, props, '水平', value)
                      }}
                    >水平</Slider>
                  </div>
                  <div className='item'>
                    <Slider
                      defaultValue={props.ifon.imageList[currentIndex].hotZone[index].y}
                      maxValue={props.ifon.imageList[currentIndex].hotZone[index].Y}
                      change={(value) => {
                        handleHotZone(currentIndex, index, props, '垂直', value)
                      }}
                    >垂直</Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>)
        })}
    </div>}

  </div >)
}

async function uploadPictures(props, e, func, func1) {
  let uptoken = await qiniuToken()
  uptoken = uptoken.data.uptoken

  const observable = qiniu.upload(e.file, `user/${Math.random().toString(36).slice(-6) + '--' + e.file.name}`, uptoken, {
    fname: e.file.name // 文件名
  }, {
    useCdnDomain: true // cdn域名加速
  })

  observable.subscribe({
    next() { },
    error(err) {
      console.log(err)
    },
    complete: (data) => {
      func1(data, e, props)
      props.ifon.imageList.length < 5 && func()
    }

  })
}

function func1(data, e, props) {
  const src = window.URL.createObjectURL(e.file)
  if (props.mySetIfon) {
    const s = e.width / 375
    const height = e.height / s
    const w = (375 / 100) * 30
    const h = (height / 100) * 30
    const x = (375 / 100) * 20
    const y = (height / 100) * 20
    props.ifon.imageList.push({
      fileIfon: {
        ...e,
        src,
        width: '100%',
        height,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        zWidth: e.width,
        zHeight: e.height,
        zSrc: 'https://ziyuan.jingxuansz.com/' + data.key
      },
      hotArea: {
        divertList: '',
        isDiverting: true,
        isSet: false,
        num: '1',
        suffixType: 'randomSuffix'
      },
      hotZone: [
        { width: w, height: h, x: x, y: y, goTo: 0, link: '', gzh: '', Width: 375 - x, Height: height - y, X: 375 - w, Y: height - h, id: Math.random() },
        { width: w, height: h, x: x, y: y, goTo: 0, link: '', gzh: '', Width: 375 - x, Height: height - y, X: 375 - w, Y: height - h, id: Math.random() },
        { width: w, height: h, x: x, y: y, goTo: 0, link: '', gzh: '', Width: 375 - x, Height: height - y, X: 375 - w, Y: height - h, id: Math.random() }
      ],
      id: Math.random(),
      isHotZone: false,
      hotZoneQuantity: [1]
    })
    props.mySetIfon(props.ifon)
  }
}

function handleHotZone(currentIndex, hotZoneIndex, props, belongTo, value) {
  let cwidth, height, top, left
  const hotIfon = props.ifon.imageList[currentIndex].hotZone[hotZoneIndex]
  const fileIfon = props.ifon.imageList[currentIndex].fileIfon
  if (belongTo === '宽度') {
    cwidth = value
    height = hotIfon.height
    top = hotIfon.y
    left = hotIfon.x
  } else if (belongTo === '高度') {
    height = value
    cwidth = hotIfon.width
    top = hotIfon.y
    left = hotIfon.x
  } else if (belongTo === '水平') {
    left = value
    top = hotIfon.y
    cwidth = hotIfon.width
    height = hotIfon.height
  } else if (belongTo === '垂直') {
    top = value
    left = hotIfon.x
    cwidth = hotIfon.width
    height = hotIfon.height
  }

  const X = 375 - cwidth
  const Y = fileIfon.height - height

  const Width = 375 - left
  const Height = fileIfon.height - top

  const obj = {
    width: cwidth,
    height,
    Width,
    Height,
    x: left,
    y: top,
    X,
    Y
  }

  props.ifon.imageList[currentIndex].hotZone[hotZoneIndex] = {
    ...props.ifon.imageList[currentIndex].hotZone[hotZoneIndex],
    ...obj
  }

  props.mySetIfon(props.ifon)
}

